import React from 'react';
import cn from 'classnames';

import { TopAsset } from '@kaltura-ott/tvpil-shared/lib/rhino/data/topAssets/types';

import DynamicRailViewer from 'components/widgets/Rail/components/DynamicRailViewer/DynamicRailViewer';
import { useRailContext } from 'components/widgets/Rail/components/RailProvider/RailProvider';
import Title from 'components/widgets/Rail/components/Title/Title';
import { useApplyStyles } from 'components/widgets/Rail/hooks/useApplyStyles/useApplyStyles';
import { useWidgetContext } from 'context/widgetProvider/widgetProvider';

import TopCardContainer from '../TopCardContainer/TopTenCardContainer';

import styles from './TopRailContainer.module.scss';

function TopRailContainer() {
  const { wrapperRef, refElementInner, componentHeight } = useRailContext();
  const { settings, data } = useWidgetContext<TopAsset>();
  const handleRef = useApplyStyles(settings);
  const { hasNextPage, totalCount, items } = data;

  return (
    <div ref={handleRef} className={cn(styles.container)}>
      <div ref={refElementInner}>
        <Title
          hasNextPage={!!hasNextPage}
          totalCount={totalCount}
          itemsLength={items.length}
          forwardHeaderRef={handleRef}
          railSettings={settings}
        />
        <div
          ref={wrapperRef}
          style={{
            height: componentHeight,
          }}
        >
          <DynamicRailViewer<TopAsset> railData={data}>
            {({ imageHeight, itemWidth, item, index }) => (
              <TopCardContainer index={index} imageHeight={imageHeight} itemWidth={itemWidth} data={item} />
            )}
          </DynamicRailViewer>
        </div>
      </div>
    </div>
  );
}

export default TopRailContainer;
